import React, { useContext, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faHome, faUser, faGraduationCap, faChalkboardUser, faSignOutAlt, faUsers, faComments, faPlus, faHeadset } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import profile from "../Images/profile.jpg";
import { SidebarContext } from '../context/SidebarContext';

const Sidebar = () => {
const {isSidebarActive, toggleSidebar} = useContext(SidebarContext)
  const navigate = useNavigate();


  const user = JSON.parse(localStorage.getItem("user"));
  const role = user ? user.role : 'Invité';

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.setItem('savedVideos', JSON.stringify([]));
    toast.info("Revenez vite nous voir ! 😄");
    navigate('/');
  };

  return (
    <main>
    <aside className={`side-bar ${isSidebarActive ? 'active' : ''}`}>
      <button id="close-btn" onClick={toggleSidebar}>
        <i className="fas fa-times"></i>
        <FontAwesomeIcon icon={faTimes} />
</button>

      <article className="profile">
        <img src={profile} className="image" alt="photo_de_profil" />
        <h3 className="name">{user ? user.login : 'Profil utilisateur'}</h3>
        <p className="role">{role}</p>
        <NavLink to="/profile" className="btn">Voir le profil</NavLink>
      </article>
      <nav className='navbar'>
  <NavLink to="/">
    <FontAwesomeIcon icon={faHome} />
    <p>Accueil</p>
  </NavLink>
  <NavLink to="/profile">
    <FontAwesomeIcon icon={faUser} />
    <p>Profil</p>
  </NavLink>
  <NavLink to="/tablature">
    <FontAwesomeIcon icon={faGraduationCap} />
    <p>Tablatures</p>
  </NavLink>
  
  {role !== 'Admin' && (
    <NavLink to="/contact">
      <FontAwesomeIcon icon={faHeadset} />
      <p>Contactez-nous</p>
    </NavLink>
  )}

  {role === 'Admin' && (
    <>
      <NavLink to="/ajout-tablature">
        <FontAwesomeIcon icon={faPlus} />
        <p>Ajout Tablatures</p>
      </NavLink>
      <NavLink to="/gestion-des-utilisateurs">
        <FontAwesomeIcon icon={faUsers} />
        <p>Utilisateurs</p>
      </NavLink>
      <NavLink to="/gestion-des-commentaires">
        <FontAwesomeIcon icon={faComments} />
        <p>Commentaires</p>
      </NavLink>
    </>
  )}

  <NavLink to="/communaute">
    <FontAwesomeIcon icon={faChalkboardUser} />
    <p>Communauté</p>
  </NavLink>

  <button className="logout-btn" onClick={handleLogout}>
    <FontAwesomeIcon icon={faSignOutAlt} />
    <p>Déconnexion</p>
  </button>
  
</nav>
</aside>
</main>
  );
};

export default Sidebar;
